module.exports = __webpack_public_path__ + "img/loading.bcd28630.gif";